import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceListEmspUserEmailHeaderProps
  extends HeaderContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['emspUser']['email']
  > {}

export const EmspBoInvoiceListEmspUserEmailHeader =
  (): // props: EmspBoInvoiceListEmspUserEmailHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-emsp-user.email');
  };
